// Mock data for Turboalgorithms.com

export const turbineModels = [
  {
    id: 'firefly-4kw',
    name: 'FireFly 4kW',
    power: 4,
    bladeLength: 5,
    sweepArea: 27.5,
    annualOutput: 16.8,
    installedCost: 20000,
    efficiency: 40,
    description: 'Compact single-blade VAWT for residential and small commercial applications',
    features: [
      'Carbon fibre single blade design',
      '40% efficiency (small wind class)',
      'TSR optimisation algorithms',
      'Remote monitoring capability',
      'Minimal maintenance required'
    ]
  },
  {
    id: 'firebird-16kw',
    name: 'FireBird 16kW',
    power: 16,
    bladeLength: 8,
    sweepArea: 100,
    annualOutput: 57.6,
    installedCost: 38000,
    efficiency: 42,
    description: 'High-performance VAWT for commercial and industrial applications',
    features: [
      'Enhanced carbon fibre composite',
      '42% efficiency rating',
      'Cloud-optimised control system',
      'Hybrid solar integration ready',
      'Encrypted power management'
    ]
  }
];

export const financialData = {
  electricityPrices: {
    'uk': 0.28,
    'germany': 0.32,
    'france': 0.21,
    'spain': 0.25,
    'usa': 0.16,
    'global-avg': 0.22
  },
  maintenanceCostPerYear: 500,
  lifetimeYears: 25,
  discountRate: 0.05
};

export const liveMetrics = {
  currentPower: 3.2,
  windSpeed: 8.3,
  tsr: 3.4,
  efficiency: 38.5,
  temperature: 24,
  todayEnergy: 45.2,
  monthEnergy: 1234,
  lifetimeEnergy: 15678,
  status: 'optimal'
};

export const performanceHistory = [
  { time: '00:00', power: 2.1, windSpeed: 6.2, tsr: 3.1 },
  { time: '04:00', power: 1.8, windSpeed: 5.5, tsr: 2.9 },
  { time: '08:00', power: 3.5, windSpeed: 8.9, tsr: 3.5 },
  { time: '12:00', power: 4.2, windSpeed: 10.2, tsr: 3.8 },
  { time: '16:00', power: 3.8, windSpeed: 9.1, tsr: 3.6 },
  { time: '20:00', power: 2.9, windSpeed: 7.4, tsr: 3.3 }
];

export const monthlyProduction = [
  { month: 'Jan', energy: 1180, revenue: 330 },
  { month: 'Feb', energy: 1050, revenue: 294 },
  { month: 'Mar', energy: 1320, revenue: 370 },
  { month: 'Apr', energy: 1450, revenue: 406 },
  { month: 'May', energy: 1380, revenue: 386 },
  { month: 'Jun', energy: 1290, revenue: 361 },
  { month: 'Jul', energy: 1250, revenue: 350 },
  { month: 'Aug', energy: 1310, revenue: 367 },
  { month: 'Sep', energy: 1420, revenue: 398 },
  { month: 'Oct', energy: 1490, revenue: 417 },
  { month: 'Nov', energy: 1380, revenue: 386 },
  { month: 'Dec', energy: 1280, revenue: 358 }
];

export const structuralHealth = {
  bladeStrain: 0.0023,
  vibrationLevel: 0.45,
  counterweightBalance: 99.2,
  towerIntegrity: 98.7,
  alerts: []
};

export const fleetData = [
  { id: 1, name: 'TB-001', lat: 51.5074, lng: -0.1278, status: 'optimal', power: 3.8 },
  { id: 2, name: 'TB-002', lat: 51.5172, lng: -0.0976, status: 'optimal', power: 4.1 },
  { id: 3, name: 'TB-003', lat: 51.4975, lng: -0.1357, status: 'maintenance', power: 0 },
  { id: 4, name: 'TB-004', lat: 51.5286, lng: -0.1015, status: 'optimal', power: 3.5 }
];

export const technologyFeatures = [
  {
    icon: 'Wind',
    title: 'Single-Blade VAWT Design',
    description: 'Maximum thickness-to-lift ratio with no inter-blade wake turbulence. Optimised TSR between 3-4 for peak efficiency.'
  },
  {
    icon: 'Layers',
    title: 'Carbon Fibre Construction',
    description: 'Advanced composite materials with internal strain gauges and horizontal strut counterweight for 100-year structural lifetime.'
  },
  {
    icon: 'Cpu',
    title: 'Cloud-Optimised Algorithms',
    description: 'Encrypted firmware with TSR regulation, wind speed sensing, and 12-point-per-rotation sampling. Data uploaded every 300 seconds.'
  },
  {
    icon: 'Zap',
    title: 'Hybrid Solar Integration',
    description: 'Seamless integration with solar panels and battery storage for 24/7 renewable energy generation and storage.'
  },
  {
    icon: 'Shield',
    title: 'Encrypted Power Management',
    description: 'Hardware-locked optimisation with trade-secret architecture. Remote shutdown capability for safety and security.'
  },
  {
    icon: 'Activity',
    title: 'Predictive Maintenance',
    description: 'Real-time structural integrity monitoring with predictive alerts. Fleet-wide analytics for optimal performance.'
  }
];

export const applications = [
  {
    title: 'Distributed Energy',
    description: 'Deploy profitable renewable infrastructure for remote communities and off-grid locations.',
    stats: '759M people without electricity globally'
  },
  {
    title: 'Agricultural Operations',
    description: 'Power irrigation systems, livestock facilities, and farm operations with reliable renewable energy.',
    stats: 'Replace diesel generators'
  },
  {
    title: 'Commercial Buildings',
    description: 'Reduce energy costs and carbon footprint with on-site renewable generation for offices and facilities.',
    stats: '4-6 year payback period'
  },
  {
    title: 'Industrial Sites',
    description: 'Supplement grid power with distributed wind generation. Hybrid solar integration for continuous supply.',
    stats: 'Up to 60% energy cost reduction'
  }
];

export const investorMetrics = {
  marketSize: '759M people without electricity',
  unitEconomics: {
    firefly: {
      installedCost: 20000,
      annualRevenue: 4704,
      tenYearNetCash: 33000,
      paybackYears: 5.2
    },
    firebird: {
      installedCost: 38000,
      annualRevenue: 16128,
      tenYearNetCash: 106000,
      paybackYears: 4.8
    }
  },
  profitPerThousandUnits: {
    low: 22000000,
    high: 106000000
  },
  roadmap: [
    { phase: 'Phase 1', target: '10 units', focus: 'Proof of concept', timeline: 'Q1-Q2 2026' },
    { phase: 'Phase 2', target: '100 units', focus: 'Regional scale', timeline: 'Q3-Q4 2026' },
    { phase: 'Phase 3', target: '1,000 units', focus: 'Infrastructure fund', timeline: '2027+' }
  ]
};

export const testimonials = [
  {
    name: 'Dr. Sarah Chen',
    role: 'Energy Research Director',
    company: 'Renewable Innovations Lab',
    quote: 'The single-blade VAWT design represents a genuine breakthrough in distributed wind energy. The efficiency metrics are exceptional.',
    avatar: 'SC'
  },
  {
    name: 'Michael Torres',
    role: 'Operations Manager',
    company: 'AgriTech Solutions',
    quote: 'We replaced our diesel generators with Turbo Algorithms turbines. ROI was achieved in under 5 years with minimal maintenance.',
    avatar: 'MT'
  },
  {
    name: 'Jennifer Walsh',
    role: 'Sustainability Officer',
    company: 'Global Infrastructure Fund',
    quote: 'The cloud-optimised monitoring and encrypted power management give us confidence in deploying at scale across our portfolio.',
    avatar: 'JW'
  }
];
